import React from "react";
import { trackSelectItem } from "analytics";
import { useCustomer } from "hooks/useStore";
import Link from "components/link";
import getProductUrl from "utils/product-url";
import { useSettings } from "hooks/useStore";
import HighlightMatch from "components/highlight-match";
import Image from "components/image";

const ProductItem = ({ product, index , customImage }) => {
	const { title, previewImages } = product;
	const { toggleSearch, toggleMenu, isSearchOpen, isMenuOpen } =
        useSettings(["toggleSearch", "toggleMenu", "isSearchOpen", "isMenuOpen"]);
	const customer = useCustomer();

	const handleProductClick = (event) => {
		event.stopPropagation();
		trackSelectItem({ ...product, index }, customer);
		if (isSearchOpen) toggleSearch();
		if (isMenuOpen) toggleMenu();
	};

	return (
		<>
			<Link to={getProductUrl(product)} onClick={handleProductClick}
				className="text-xs font-basefont-normal bg-lightBeige  md:hidden  flex items-center flex-wrap">
				<div className=" T74-mobile-menu-images"> 
					<Image image={customImage || previewImages[0]}/> 
				</div>
				<span className=" p-1 "> <HighlightMatch text={title}/> </span>
			</Link>

		</>
	);
};

export default ProductItem;
